import { z } from 'zod'

const AmountSchema = z.object({
  amount: z.number().optional(),
  currencyCode: z.string().optional(),
})

export const PromotionSchema = z.object({
  type: z.string(),
  code: z.string().optional(),
  promoCode: z.string().optional(),
  description: z.string().optional(),
  initialTotalAmount: AmountSchema.optional(),
  initialLoyaltyAmount: AmountSchema.optional(),
  earnedPoints: AmountSchema.optional(),
})
